import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { riskManagementStatus } from 'constants/risk-management';
import { getRiskManagementLastConsultations } from 'services/riskManagement';
import { IRiskManagementLastConsultationsResponse } from 'services/riskManagement/types';

export const RISK_MANAGEMENT_LAST_CONSULTATIONS_QUERY_KEY = 'rm-last-consultations-key';

export const useGetRiskManagementLastConsultations = (
  truckerId: string | undefined,
  options?: UseQueryOptions<IRiskManagementLastConsultationsResponse, Error>,
  rmStatus = riskManagementStatus.SECURITY_PROFILE_WITH.status
) =>
  useQuery<IRiskManagementLastConsultationsResponse, Error>({
    queryKey: [RISK_MANAGEMENT_LAST_CONSULTATIONS_QUERY_KEY, truckerId],
    queryFn: () => getRiskManagementLastConsultations(truckerId, rmStatus),
    enabled: !!truckerId,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    gcTime: 0,
    ...options,
  });
